import type { ReferentialAssetTypeCategorie } from "./referential-asset-type-categories.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_NAMES } from "@/entities/referential";

export const useReferentialAssetTypeCategories = (
  options?: UseReferentialOptions<ReferentialAssetTypeCategorie[]>
) => {
  const { data, ...result } = useReferential<ReferentialAssetTypeCategorie[]>(
    REFERENTIAL_NAMES.ASSET_TYPE_CATEGORIES,
    options
  );

  return {
    assetTypeCategories: data ?? [],
    ...result,
  };
};
